export default "__VITE_ASSET__DHZAa173__"